import httpClient from "../apiClient";
import { TGetPlansListRequest } from "./index.types";

export class PlansAPI {
  static getPlansListRequest: TGetPlansListRequest = () => httpClient.post("/plans");
}
